import { render, staticRenderFns } from "./CopyColor.vue?vue&type=template&id=4ff5da4d&scoped=true"
import script from "./CopyColor.vue?vue&type=script&lang=js"
export * from "./CopyColor.vue?vue&type=script&lang=js"
import style0 from "./CopyColor.vue?vue&type=style&index=0&id=4ff5da4d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff5da4d",
  null
  
)

export default component.exports